/* Litborne — collection artwork grouping v1
   Section lb-main-collection-grouped chi render 1 the/artwork (uu tien handbag) va nhung JSON
   tat ca san pham trong trang vao script.lb-grp-data. File nay:
   - gom JSON theo artwork (f), sap theo rank (handbag truoc)
   - them hang swatch duoi gia cua the dai dien
   - bam swatch: doi anh / tieu de / gia / link / quick-add ngay tren the, khong roi trang
   - infinite scroll mang trang sau ve: nap them JSON, bo the trung artwork */
(function () {
  if (window.__lbGrp) return;
  window.__lbGrp = true;

  var DATA = {};
  var FAMS = {};
  function maxVisible() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 3 : 5; }

  /* LB-SW-FIT v2: so swatch hien = so o vua 1 hang theo be rong the; tu dem lai khi hang doi be rong (doi 1/2 cot, xoay may) */
  function fitRow(row) {
    if (!row || !row.isConnected) return;
    var li = row.closest('li');
    var more = row.querySelector('.lb-grp__more');
    if (li && li.classList.contains('lb-grp-open')) { if (more && more.parentNode) more.parentNode.removeChild(more); return; }
    var sws = row.querySelectorAll('.lb-grp__sw');
    var n = sws.length; if (!n) return;
    var w = row.clientWidth;
    var sw = sws[0].offsetWidth || (more && more.offsetWidth) || 0;
    var cs = getComputedStyle(row);
    var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 6;
    var vis;
    if (!w || !sw) { vis = maxVisible(); }
    else {
      var fit = Math.max(1, Math.floor((w + gap) / (sw + gap)));
      vis = n <= fit ? n : Math.max(1, fit - 1);
    }
    for (var i = 0; i < n; i++) sws[i].classList.toggle('lb-grp__sw--x', i >= vis);
    if (n > vis) {
      if (!more) { more = document.createElement('button'); more.type = 'button'; more.className = 'lb-grp__more'; row.appendChild(more); }
      var txt = '+' + (n - vis);
      if (more.textContent !== txt) more.textContent = txt;
      if (more.style.display) more.style.display = '';
    } else if (more && more.style.display !== 'none') { more.style.display = 'none'; }
  }
  var lbQ = [], lbRaf = 0;
  var lbRO = window.ResizeObserver ? new ResizeObserver(function (es) {
    for (var i = 0; i < es.length; i++) if (lbQ.indexOf(es[i].target) < 0) lbQ.push(es[i].target);
    if (lbRaf) return;
    lbRaf = requestAnimationFrame(function () { var q = lbQ; lbQ = []; lbRaf = 0; q.forEach(fitRow); });
  }) : null;
  function watchRow(row) {
    if (lbRO) lbRO.observe(row);
  }
  if (!lbRO) {
    var lbFitT;
    window.addEventListener('resize', function () {
      clearTimeout(lbFitT);
      lbFitT = setTimeout(function () { document.querySelectorAll('.lb-grp__row').forEach(fitRow); }, 150);
    });
  }
  var LABEL = {
    'Leather Handbag': 'Handbag',
    'Small Leather Handbag': 'Small Handbag',
    'Leather Tote Bag': 'Tote',
    'Leather Backpack': 'Backpack',
    'Mini Satchel': 'Mini Satchel',
    'Bat Wing Handbag': 'Bat Wing Bag',
    'Circle Crossbody Bag': 'Crossbody',
    'Envelope Chain Crossbody Bag': 'Envelope Bag',
    'Long Wallet': 'Long Wallet',
    'Wallet': 'Long Wallet',
    'Mini Wallet': 'Mini Wallet',
    'Eclipse Makeup Bag': 'Makeup Bag'
  };


  /* LB-XFAM v3 (21/09: preload dung anh khi cham, loading state, retry; GIU co anh to) — v2 (21/09: doi anh ngay, gia tai sau co retry) — goc v1: collection chi co 1 mon/artwork (The Belfry, Halloween) -> bo sung ca bo artwork tu lb-set-index.json.
     Mon bo sung (x:1) khong co gia trong trang: lay tu /products/<h>.js (tien te khach dang xem) khi can. */
  var XIDX = null, XIDX_LOADING = false;
  var XORDER = ['Leather Handbag', 'Small Leather Handbag', 'Bat Wing Handbag', 'Leather Tote Bag', 'Leather Backpack', 'Mini Satchel',
    'Circle Crossbody Bag', 'Envelope Chain Crossbody Bag', 'Long Wallet', 'Wallet', 'Mini Wallet', 'Eclipse Makeup Bag'];
  function xHolder() { return document.querySelector('li.lb-grp-holder[data-lb-xfam="1"]'); }
  function xLoad() {
    var hd = xHolder();
    if (!hd || XIDX || XIDX_LOADING) return;
    var url = hd.getAttribute('data-lb-idx');
    if (!url) return;
    XIDX_LOADING = true;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { XIDX = d; XIDX_LOADING = false; run(); })
      .catch(function () { XIDX_LOADING = false; });
  }
  function xNorm(s) { return String(s || '').toLowerCase().replace(/["“”'’]/g, '').replace(/\s+/g, ' ').trim(); }
  function xRank(ty, bi) {
    var i = XORDER.indexOf(ty);
    return (i < 0 ? 99 : (i + 1) * 2) + (bi ? 1 : 0);
  }
  function xImg(u, w) { return u ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : ''; }
  function xAugment() {
    if (!XIDX || !XIDX.fams || !xHolder()) return;
    var byNorm = {};
    Object.keys(XIDX.fams).forEach(function (f) { byNorm[xNorm(f)] = f; });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Object.keys(FAMS).forEach(function (f) {
      var key = XIDX.fams[f] ? f : byNorm[xNorm(f)];
      var mem = key ? XIDX.fams[key] : null;
      if (!mem) return;
      var add = [];
      mem.forEach(function (m) {
        if (!m || !m.h || DATA[m.h]) return;
        var bi = /black interior/i.test(m.t || '');
        add.push({ h: m.h, f: f, ty: m.ty, bi: bi, r: xRank(m.ty, bi), t: m.t, u: root + 'products/' + m.h + (m.vid ? '?variant=' + m.vid : ''),
          p: null, v: m.vid, pid: null, img: xImg(m.img, 900), th: xImg(m.img, 160), x: 1 });
      });
      if (add.length) addItems(add);
      /* mon nam trong chinh collection (vd tui doi o The Belfry) dung dau hang swatch */
      FAMS[f].forEach(function (it) { if (!it.x) it.r = -1; });
    });
    sortFams();
  }
  /* dinh dang so tien giong mau dang hien tren the (vd "$99.99", "1.318.000₫", "£79.99") */
  function xFmtLike(sample, minor) {
    var m = String(sample || '').match(/\d[\d.,\s ]*\d|\d/);
    var val = minor / 100;
    if (!m) return '$' + val.toFixed(2);
    var num = m[0];
    var dec = num.match(/[.,](\d{2})$/) && !/^\d{1,3}([.,]\d{3})+$/.test(num) ? num.slice(-3, -2) : null;
    var th = null;
    var rest = dec ? num.slice(0, -3) : num;
    var tm = rest.match(/\d([.,\s ])\d{3}/);
    if (tm) th = tm[1];
    var ip = dec ? Math.floor(Math.round(val * 100) / 100) : Math.round(val);
    if (!th && dec && ip >= 1000) th = dec === '.' ? ',' : '.';
    var ints = String(ip);
    if (th) ints = ints.replace(/\B(?=(\d{3})+(?!\d))/g, th);
    var out = dec ? ints + dec + (Math.round(val * 100) % 100 + 100).toString().slice(1) : ints;
    return String(sample).replace(num, out);
  }
  var XPRICE = {};
  /* LB-XFAM v2: tai gia co retry (3 lan, gian cach tang dan); that bai thi bo cache de lan bam sau thu lai */
  function xFetchPrice(it, sample, attempt) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'products/' + it.h + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (js) {
        var vs = js.variants || [];
        var v = vs.filter(function (x) { return String(x.id) === String(it.v); })[0] || vs.filter(function (x) { return x.available; })[0] || vs[0];
        if (v) { it.v = v.id; it.p = xFmtLike(sample, v.price); it.u = root + 'products/' + it.h + '?variant=' + v.id; }
        it.pid = js.id;
        return it;
      })
      .catch(function () {
        if (attempt < 2) {
          return new Promise(function (res) { setTimeout(res, 1200 * (attempt + 1)); }).then(function () { return xFetchPrice(it, sample, attempt + 1); });
        }
        delete XPRICE[it.h];
        return it;
      });
  }
  function xPrice(it, sample) {
    if (!it || !it.x || it.p) return Promise.resolve(it);
    if (XPRICE[it.h]) return XPRICE[it.h];
    XPRICE[it.h] = xFetchPrice(it, sample, 0);
    return XPRICE[it.h];
  }
  /* LB-XFAM v3: preload dung anh dang dung (giu co anh to), khong tai trung */
  var XPRE = {};
  function xPreload(u) { if (!u || XPRE[u]) return; XPRE[u] = 1; var im = new Image(); im.src = u; }
  function xSample(li) {
    var hero = DATA[li.getAttribute('data-lb-h')];
    return hero && hero.p ? hero.p : '';
  }
  /* tai truoc gia khi khach cham/ho vao hang swatch */
  document.addEventListener('pointerover', function (e) {
    var row = e.target && e.target.closest ? e.target.closest('.lb-grp__row') : null;
    if (!row || row.__lbPre) return;
    row.__lbPre = 1;
    var li = row.closest('li.product-grid__item');
    var arr = li ? FAMS[li.getAttribute('data-lb-fam')] || [] : [];
    var smp = li ? xSample(li) : '';
    /* LB-XFAM v2: tai truoc anh de bam la doi ngay (chi may co chuot, toi da 6 anh); gia tai tuan tu cach 250ms de khong bung 9 request */
    if (window.matchMedia && matchMedia('(hover: hover)').matches) {
      arr.slice(0, 6).forEach(function (it) { if (it.img) xPreload(it.img); });
    }
    arr.filter(function (it) { return it.x && !it.p; }).forEach(function (it, i) {
      setTimeout(function () { xPrice(it, smp); }, 250 * i);
    });
  }, { passive: true });

  function lbl(it) {
    var s = LABEL[it.ty] || it.ty || 'Style';
    if (it.bi) s += ' · Black Interior';
    return s;
  }

  var PAGES_DONE = {};
  var PAGE_TRIES = {};
  var PAGES_FETCHING = false;
  var SIG = null;
  var EXTRA = {};        /* queryKey -> { page: [items] } nap them qua fetch (trang > 1) */

  function addItems(arr) {
    var changed = false;
    for (var i = 0; i < arr.length; i++) {
      var it = arr[i];
      if (!it || !it.h || DATA[it.h]) continue;
      DATA[it.h] = it;
      (FAMS[it.f] = FAMS[it.f] || []).push(it);
      changed = true;
    }
    return changed;
  }

  function sortFams() {
    Object.keys(FAMS).forEach(function (f) {
      FAMS[f].sort(function (a, b) { return a.r - b.r; });
    });
  }

  /* Khoa theo bo loc/sort (khong tinh page, section_id) — du lieu trang sau luu rieng theo khoa nay */
  function queryKey() {
    try {
      var u = new URL(window.location.href);
      var keep = [];
      u.searchParams.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'sort_by') keep.push(k + '=' + v); });
      keep.sort();
      return u.pathname + '?' + keep.join('&');
    } catch (e) { return window.location.pathname; }
  }

  function domScripts() { return document.querySelectorAll('script.lb-grp-data'); }

  /* Dung lai DATA/FAMS tu CHINH khoi JSON dang co trong trang moi khi noi dung doi.
     Khong dua vao URL: theme doi URL truoc roi moi tai HTML moi ve (loc/sort AJAX). */
  function rebuild(force) {
    var sc = domScripts();
    var parts = [];
    var items = [];
    for (var i = 0; i < sc.length; i++) {
      var txt = sc[i].textContent;
      parts.push(txt.length + ':' + txt.slice(0, 60) + txt.slice(-60));
      try { items = items.concat(JSON.parse(txt)); } catch (e) {}
    }
    var qk = queryKey();
    var ex = EXTRA[qk] || {};
    var sig = qk + '|' + parts.join('|') + '|x' + Object.keys(ex).join(',') + '|i' + (XIDX ? 1 : 0);
    if (!force && sig === SIG) return false;
    SIG = sig;
    DATA = {};
    FAMS = {};
    addItems(items);
    Object.keys(ex).forEach(function (p) { addItems(ex[p]); });
    xAugment();
    sortFams();
    PAGES_DONE = {};
    for (var s = 0; s < sc.length; s++) {
      var pg = parseInt(sc[s].getAttribute('data-lb-page'), 10);
      if (pg) PAGES_DONE[pg] = true;
    }
    Object.keys(ex).forEach(function (p) { PAGES_DONE[p] = true; });
    var lis = document.querySelectorAll('li.product-grid__item[data-lb-n]');
    for (var j = 0; j < lis.length; j++) lis[j].removeAttribute('data-lb-n');
    return true;
  }

  /* Shopify cat collection toi da 50 san pham/trang: nap JSON cac trang con lai qua section rendering */
  function fetchMissingPages() {
    if (PAGES_FETCHING) return;
    var holder = document.querySelector('li.lb-grp-holder[data-lb-pages]');
    if (!holder) return;
    var pages = parseInt(holder.getAttribute('data-lb-pages'), 10) || 1;
    var sid = holder.getAttribute('data-lb-section');
    if (pages < 2 || !sid) return;
    var qk = queryKey();
    var todo = [];
    for (var p = 1; p <= pages; p++) if (!PAGES_DONE[p] && (PAGE_TRIES[qk + '#' + p] || 0) < 2) todo.push(p);
    if (!todo.length) return;
    PAGES_FETCHING = true;
    var jobs = todo.map(function (p) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', String(p));
      u.searchParams.set('section_id', sid);
      return fetch(u.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sc = doc.querySelector('script.lb-grp-data');
          var arr = [];
          if (sc) { try { arr = JSON.parse(sc.textContent); } catch (e) {} }
          (EXTRA[qk] = EXTRA[qk] || {})[p] = arr;
          return true;
        })
        .catch(function () {
          var key = qk + '#' + p;
          PAGE_TRIES[key] = (PAGE_TRIES[key] || 0) + 1;
          return false;
        });
    });
    Promise.all(jobs).then(function (res) {
      PAGES_FETCHING = false;
      if (qk !== queryKey()) return;            /* bo loc da doi trong luc tai -> bo ket qua cu */
      if (res.some(Boolean) && rebuild(true)) {
        var lis = document.querySelectorAll('li.product-grid__item[data-lb-fam]');
        for (var i = 0; i < lis.length; i++) enhance(lis[i]);
      }
    });
  }

  function dedupe() {
    var seen = {};
    var lis = document.querySelectorAll('li.product-grid__item[data-lb-fam]');
    for (var i = 0; i < lis.length; i++) {
      var f = lis[i].getAttribute('data-lb-fam');
      if (seen[f]) {
        if (lis[i].parentNode) lis[i].parentNode.removeChild(lis[i]);
      } else {
        seen[f] = lis[i];
      }
    }
  }

  function mark(li, h) {
    var it = DATA[h];
    var arr = FAMS[li.getAttribute('data-lb-fam')] || [];
    var sws = li.querySelectorAll('.lb-grp__sw');
    for (var i = 0; i < sws.length; i++) {
      sws[i].classList.toggle('is-active', sws[i].getAttribute('data-h') === h);
    }
    var lab = li.querySelector('.lb-grp__lbl');
    if (lab && it) lab.textContent = arr.length + ' styles · ' + lbl(it);
  }

  function enhance(li) {
    var f = li.getAttribute('data-lb-fam');
    var arr = FAMS[f];
    var card = li.querySelector('product-card');
    if (!card || !arr || arr.length < 2) return;
    if (li.getAttribute('data-lb-n') === String(arr.length)) return;
    li.setAttribute('data-lb-n', String(arr.length));

    var old = card.querySelector('.lb-grp');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var box = document.createElement('div');
    box.className = 'lb-grp';
    var lab = document.createElement('div');
    lab.className = 'lb-grp__lbl';
    box.appendChild(lab);

    var row = document.createElement('div');
    row.className = 'lb-grp__row';
    var MAXV = maxVisible();
    arr.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lb-grp__sw' + (i >= MAXV ? ' lb-grp__sw--x' : '');
      b.setAttribute('data-h', it.h);
      b.setAttribute('aria-label', lbl(it));
      b.title = lbl(it);
      if (it.th) b.style.backgroundImage = 'url("' + it.th + '")';
      row.appendChild(b);
    });
    if (arr.length > MAXV) {
      var m = document.createElement('button');
      m.type = 'button';
      m.className = 'lb-grp__more';
      m.textContent = '+' + (arr.length - MAXV);
      row.appendChild(m);
    }
    box.appendChild(row);

    if (old && lbRO) { var oldRow = old.querySelector('.lb-grp__row'); if (oldRow) lbRO.unobserve(oldRow); }
    var anchor = card.querySelector('product-price');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(box, anchor.nextSibling);
    } else {
      (card.querySelector('.product-card__content') || card).appendChild(box);
    }
    fitRow(row);
    watchRow(row);
    mark(li, li.getAttribute('data-lb-cur') || li.getAttribute('data-lb-h'));
  }

  function galleryImgs(card) {
    var g = card.querySelector('[ref="cardGallery"]') || card.querySelector('.card-gallery');
    return g ? g.querySelectorAll('img') : [];
  }

  function swap(li, h) {
    var it = DATA[h];
    var card = li.querySelector('product-card');
    if (!it || !card) return;
    /* LB-XFAM v2: KHONG cho gia nua — doi anh/ten/link ngay, gia dien sau */
    var pending = !!(it.x && !it.p);
    li.setAttribute('data-lb-want', h);
    var hero = li.getAttribute('data-lb-h');

    if (!li.__lbOrig || li.__lbOrigHero !== hero) {
      li.__lbOrigHero = hero;
      li.__lbOrig = [];
      var ims = galleryImgs(card);
      for (var i = 0; i < ims.length; i++) {
        li.__lbOrig.push([ims[i], ims[i].getAttribute('src'), ims[i].getAttribute('srcset'), ims[i].getAttribute('sizes')]);
      }
    }
    li.__lbOrig.forEach(function (r) {
      var im = r[0];
      if (h === hero) {
        if (r[1]) im.setAttribute('src', r[1]);
        if (r[2]) im.setAttribute('srcset', r[2]); else im.removeAttribute('srcset');
        if (r[3]) im.setAttribute('sizes', r[3]);
      } else if (it.img) {
        im.removeAttribute('srcset');
        im.setAttribute('src', it.img);
      }
    });
    /* LB-XFAM v3: bao dang tai — mo gallery toi khi anh moi decode xong; loi thi thu lai 1 lan; 8s thi bo mo */
    (function () {
      var g = card.querySelector('[ref="cardGallery"]') || card.querySelector('.card-gallery');
      var first = li.__lbOrig.length ? li.__lbOrig[0][0] : null;
      if (!g || !first) return;
      var token = (li.__lbLoadTok = (li.__lbLoadTok || 0) + 1);
      var done = function () { if (li.__lbLoadTok === token) g.classList.remove('lb-grp-loading'); };
      if (first.complete && first.naturalWidth) { done(); return; }
      g.classList.add('lb-grp-loading');
      var tries = 0;
      first.onload = done;
      first.onerror = function () {
        if (li.__lbLoadTok !== token) return;
        if (tries++ < 1 && it.img && h !== hero) first.setAttribute('src', it.img + (it.img.indexOf('?') < 0 ? '?' : '&') + '_r=' + Date.now());
        else done();
      };
      setTimeout(done, 20000);   /* v3.1: anh to tren mang cham co the > 8s, giu mo toi 20s */
    })();

    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var a = 0; a < links.length; a++) links[a].setAttribute('href', it.u);
    var gl = card.querySelector('[ref="cardGalleryLink"]');
    if (gl) gl.setAttribute('aria-label', it.t);

    var titles = card.querySelectorAll('p[role="heading"], .product-grid-view-zoom-out--details h3, .product-card__link .visually-hidden');
    for (var t = 0; t < titles.length; t++) titles[t].textContent = it.t;

    var price = card.querySelector('product-price .price__regular .price');
    var reg = card.querySelector('product-price .price__regular');
    var s26 = card.querySelector('.lb-s26-card');
    if (s26 && s26.parentNode) s26.parentNode.removeChild(s26); /* litborne-summer26.js ve lai gia sale */
    if (pending) {
      /* an gia trong luc cho: class price__hidden de summer26 khong ve gia cua mon cu */
      if (reg) { reg.classList.add('price__hidden'); reg.style.display = 'none'; }
      xPrice(it, xSample(li)).then(function () {
        if (li.getAttribute('data-lb-want') !== h || !it.p) return;   /* da bam sang mon khac, hoac tai gia that bai: giu anh, khong hien gia sai */
        if (price) price.textContent = it.p;
        if (reg) { reg.classList.remove('price__hidden'); reg.style.display = ''; }
        var s2 = card.querySelector('.lb-s26-card');
        if (s2 && s2.parentNode) s2.parentNode.removeChild(s2);
        var v2 = card.querySelector('input[name="id"]'); if (v2) v2.value = it.v;
        var p2 = card.querySelector('input[name="product-id"]'); if (p2 && it.pid) p2.value = it.pid;
        var l2 = card.querySelectorAll('a[href*="/products/"]'); for (var a2 = 0; a2 < l2.length; a2++) l2[a2].setAttribute('href', it.u);
      });
    } else {
      if (price) price.textContent = it.p;
      if (reg) { reg.classList.remove('price__hidden'); reg.style.display = ''; }
    }

    var vid = card.querySelector('input[name="id"]');
    if (vid) vid.value = it.v;
    var pidIn = card.querySelector('input[name="product-id"]');
    if (pidIn && it.pid) pidIn.value = it.pid;
    var atc = card.querySelector('add-to-cart-component');
    if (atc && it.th) atc.setAttribute('data-product-variant-media', it.th);
    if (it.pid) {
      var pidEls = [card].concat(Array.prototype.slice.call(card.querySelectorAll('[data-product-id]')));
      pidEls.forEach(function (el) { el.setAttribute('data-product-id', it.pid); });
    }

    li.setAttribute('data-lb-cur', h);
    mark(li, h);
  }

  document.addEventListener('pointerdown', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.lb-grp__sw') : null;
    if (!t) return;
    var it = DATA[t.getAttribute('data-h')];
    if (it && it.img) xPreload(it.img);
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.lb-grp__sw, .lb-grp__more') : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    var li = t.closest('li.product-grid__item');
    if (!li) return;
    if (t.classList.contains('lb-grp__more')) {
      li.classList.add('lb-grp-open');
      if (t.parentNode) t.parentNode.removeChild(t);
      return;
    }
    swap(li, t.getAttribute('data-h'));
  }, true);

  function run() {
    xLoad();
    rebuild(false);
    dedupe();
    var lis = document.querySelectorAll('li.product-grid__item[data-lb-fam]');
    for (var i = 0; i < lis.length; i++) enhance(lis[i]);
    fetchMissingPages();
  }

  var timer = null;
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var tg = ms[i].target;
      if (tg && tg.nodeType === 3) tg = tg.parentElement;
      if (tg && tg.closest && (tg.closest('.lb-count') || tg.closest('.lb-grp'))) continue;
      if (ms[i].addedNodes && ms[i].addedNodes.length) {
        clearTimeout(timer);
        timer = setTimeout(run, 60);
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
